import { Outlet } from 'react-router';
import { AzureProvider } from './lib/api/auth';
import AppInsightsProvider from './lib/contexts/AppInsightsProvider';
import ConfigurationProvider from './lib/contexts/ConfigurationContext/ConfigurationContext';
import GlobalContextProvider from './lib/contexts/GlobalContextProvider';
import TimeoutProvider from './lib/contexts/TimeoutProvider';
import ToastProvider from './lib/contexts/ToastProvider';
import BootstrapApp from './lib/helper/components/BootstrapApp';

const Bootstrap = () => {
    return (
        <AppInsightsProvider>
            <AzureProvider>
                <BootstrapApp>
                    <GlobalContextProvider>
                        <ConfigurationProvider>
                            <TimeoutProvider>
                                <ToastProvider />
                                <Outlet />
                            </TimeoutProvider>
                        </ConfigurationProvider>
                    </GlobalContextProvider>
                </BootstrapApp>
            </AzureProvider>
        </AppInsightsProvider>
    );
};

export default Bootstrap;
